import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsBlConstants {
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static DESCRIPTION_LABEL = "Description";
    static TYPE_LABEL = "Application type";
    static TRADE_NAME_LABEL = "Trade name under which business to be conducted?";
    static BUSINESS_OWNER_LABEL = "Business owner";
    static BUSINESS_OWNER_HEADING = "Business owner";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static TYPE_FORM_CONTROL_NAME = "type";
    static TRADE_NAME_CONTROL = "tradeName";
    static BUSINESS_OWNER_CONTROL = "businessOwner";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        tradeName: {
            required: `Trade name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        businessOwner: {
            required: `Business owner ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
